import { Flex } from '@workwhile/ui'
import React from 'react'
import { useI9HubContextValue } from '../../context/I9HubProvider'
import { GroupByAttributesSelector } from '../GroupByAttributesSelector'
import type { AltDocsDateSort, AltDocsGroupBy } from '../../context/i9HubRows'
import { I9HubWorkerUrlFilters } from './I9HubWorkerUrlFilters'

const ALT_DOCS_GROUP_BY_OPTIONS: { label: string; value: AltDocsGroupBy }[] = [
  { label: 'Date', value: 'date' },
  { label: 'State', value: 'state' },
  { label: 'Market', value: 'market' },
]

const ALT_DOCS_DATE_SORT_OPTIONS: { label: string; value: AltDocsDateSort }[] =
  [
    { label: 'Oldest first', value: 'asc' },
    { label: 'Newest first', value: 'desc' },
  ]

export function I9AltDocsHubFilters() {
  const {
    state: {
      altDocs: {
        stateSelectOptions,
        marketSelectOptions,
        filters,
        groupBy,
        dateSort,
      },
    },
    actions: { setAltDocsQuery },
  } = useI9HubContextValue()

  return (
    <Flex flexDirection="row" flexWrap="wrap" gap={2} alignItems="flex-start">
      <Flex flexDirection="row" flexWrap="wrap" gap={2} alignItems="center">
        <I9HubWorkerUrlFilters
          stateSelectOptions={stateSelectOptions}
          marketSelectOptions={marketSelectOptions}
          filters={filters}
          onFiltersChange={(patch) =>
            setAltDocsQuery({
              ...(patch.state !== undefined ? { altState: patch.state } : {}),
              ...(patch.market !== undefined
                ? { altMarket: patch.market }
                : {}),
              ...(patch.workerId !== undefined
                ? { altWorkerId: patch.workerId }
                : {}),
              ...(patch.workerSearch !== undefined
                ? { altWorkerSearch: patch.workerSearch }
                : {}),
            })
          }
        />
      </Flex>
      <Flex ml={4} flexWrap="wrap" gap={2} alignItems="flex-start">
        <GroupByAttributesSelector
          label="Group by"
          filterKey="alt-group-by"
          options={ALT_DOCS_GROUP_BY_OPTIONS}
          value={groupBy}
          onChange={(next) =>
            setAltDocsQuery({ altGroupBy: next as AltDocsGroupBy })
          }
        />
        {groupBy === 'date' ? (
          <GroupByAttributesSelector
            label="Date order"
            filterKey="alt-date-sort"
            options={ALT_DOCS_DATE_SORT_OPTIONS}
            value={dateSort}
            rootGroupTitle="Sort"
            onChange={(next) =>
              setAltDocsQuery({ altDateSort: next as AltDocsDateSort })
            }
          />
        ) : null}
      </Flex>
    </Flex>
  )
}
